import { LitElement, html } from 'lit'

/**
 * BotÃ£o flutuante (FAB) para aÃ§Ãµes rÃ¡pidas
 * Posicionado fixo no canto inferior direito da tela
 * Utiliza tokens CSS do Design System para cores e hover
 */
export class FloatingButton extends LitElement {
  createRenderRoot() {
    return this
  }

  static get properties() {
    return {
      icon: { type: String }
    }
  }

  constructor() {
    super()
    this.icon = '+'
  }

  /**
   * Dispara evento customizado ao clicar no botÃ£o
   * Emite 'floating-button-click' com a action definida no atributo
   */
  _handleClick() {
    this.dispatchEvent(new CustomEvent('floating-button-click', {
      detail: { 
        action: this.getAttribute('action') || 'default'
      },
      bubbles: true,
      composed: true
    }))
  }

  render() {
    return html`
      <button 
        class="button fab" 
        data-cy="floating-button"
        @click="${this._handleClick}"
        style="
          position: fixed;
          bottom: 90px;
          right: 20px;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: var(--primary, #6120D8);
          color: var(--secondary, #11C5B8);
          box-shadow: var(--shadow-card, 0 10px 40px rgba(0,0,0,0.35));
          z-index: 10001;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          border: none;
          min-width: unset;
          padding: 0;
          line-height: 1;
          cursor: pointer;
          transition: background-color 0.2s ease;
        "
        @mouseenter="${this._onHover}"
        @mouseleave="${this._onLeave}"
      >
        <i class="fas fa-plus"></i>
      </button>
    `
  }

  /**
   * Aplica cor de hover ao passar o mouse sobre o botÃ£o
   * @param {Event} e - Evento de mouseenter
   * @private
   */
  _onHover(e) {
    e.target.style.backgroundColor = 'var(--hover-primary, #7B3EF0)'
  }

  /**
   * Restaura cor original ao remover o mouse do botÃ£o
   * @param {Event} e - Evento de mouseleave
   * @private
   */
  _onLeave(e) {
    e.target.style.backgroundColor = 'var(--primary, #6120D8)'
  }
}

customElements.define('floating-button', FloatingButton)
